// extracted by mini-css-extract-plugin
export default {"addCheckpointForm":"AddCheckpointForm_addCheckpointForm__7Nywd","addCheckpointForm__submit":"AddCheckpointForm_addCheckpointForm__submit__XmcZs"};